<app-loading-spinner *ngIf="isLoading" ></app-loading-spinner>

<div *ngIf="!isLoading" class="table-responsive p-l-20 p-r-20 sectionBox m-t-20">
  <table class="table align-middle tableStyle">
    <thead>
    <tr>
      <th class="col-3">Automation Rules</th>
      <th class="col">Description</th>
      <th class="col-2">Request Type</th>
      <th class="col-2">Created
        <span>
          <i [matTooltip]="'If empty, the automation rule was created before the Date field was implemented.'"
          [matTooltipPosition]="'above'" [matTooltipClass]="'sdesk-tooltip'"
          class="far fa-question-circle m-l-5"></i>
        </span>
      </th>
      <th class="col-2">Updated
        <span>
          <i [matTooltip]="'If empty, the automation rule was created before the Date field was implemented.'"
          [matTooltipPosition]="'above'" [matTooltipClass]="'sdesk-tooltip'"
          class="far fa-question-circle m-l-5"></i>
        </span>
      </th>
      <th class="col-2">
        <div (click)="create()" class="btn btn-primary float-end">Create</div>
      </th>

    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of this.data ">
      <td><span class="divLink" (click)="edit(row.Id)">{{row.Name}}</span></td>
      <td> {{row.Description}}</td>
      <td>{{row.TypeName}}</td>
      <td>{{row.DateTimeCreated}}</td>
      <td>{{row.DateTimeUpdated}}</td>
      <td><i class="far fa-trash-alt float-end m-r-20 divLink" (click)="delete(row.Id)"></i>
        <i class="fas fa-cog float-end m-r-20 divLink" (click)="edit(row.Id)"></i></td>
    </tr>
    </tbody>
  </table>
</div>
